import React, {useState} from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import clsx from 'clsx';

import EndCallButton from './EndCallButton/EndCallButton';
import ToggleAudioButton from './ToggleAudioButton/ToggleAudioButton';
import ToggleVideoButton from './ToggleVideoButton/ToggleVideoButton';

import useIsUserActive from './useIsUserActive/useIsUserActive';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import SettingsButton from "./SettingsButton/SettingsButton";
import SettingsDialog from "../MenuBar/SettingsDialog/SettingsDialog";
import CancelConnectButton from "./CancelConnectButton/CancelConnectButton";
import Button from '@material-ui/core/Button';
import PlayArrow from '@material-ui/icons/PlayArrow';
import useVideoContext from "../../hooks/useVideoContext/useVideoContext";
import {useLocalAudioTrack} from "../VideoProvider/useLocalTracks/useLocalTracks";
import useLocalVideoToggle from "../../hooks/useLocalVideoToggle/useLocalVideoToggle";
import useLocalAudioToggle from "../../hooks/useLocalAudioToggle/useLocalAudioToggle";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            position: 'absolute',
            right: '50%',
            transform: 'translate(50%, 30px)',
            bottom: '50px',
            zIndex: 1,
            transition: 'opacity 1.2s, transform 1.2s, visibility 0s 1.2s',
            opacity: 0,
            visibility: 'hidden',
            maxWidth: 'min-content',
            '&.showControls, &:hover': {
                transition: 'opacity 0.6s, transform 0.6s, visibility 0s',
                opacity: 1,
                visibility: 'visible',
                transform: 'translate(50%, 0px)',
            },
            [theme.breakpoints.down('xs')]: {
                bottom: `${theme.sidebarMobileHeight + 3}px`,
            },
        },
        button: {
            margin: theme.spacing(1),
        },
    })
);

export default function Controls(props: {
    hideVideoChat: () => void,
    callConnect: () => void,
}) {
    const classes = useStyles();
    const roomState = useRoomState();
    const isReconnecting = roomState === 'reconnecting';
    const isUserActive = useIsUserActive();
    const showControls = isUserActive || roomState === 'disconnected';
    const [settingsOpen, setSettingsOpen] = useState(false);
    const {room} = useVideoContext();
    const {audioTrack} = useLocalAudioTrack();
    const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();
    const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
    const killChat = () => {
        if(isAudioEnabled)
            toggleAudioEnabled()

        audioTrack?.stop()
        // getLocalAudioTrack().then((at) => {
        //     at.disable()
        //     at.enable()
        //     at.stop()
        // })

        if(isVideoEnabled)
            toggleVideoEnabled()

        if (roomState !== 'disconnected') {
            room.disconnect()
        }

        props.hideVideoChat()
    }

    return (
        <div className={clsx(classes.container, {showControls})}>
            <ToggleAudioButton disabled={isReconnecting}/>
            <ToggleVideoButton disabled={isReconnecting}/>
            {roomState !== 'disconnected' ? (
                <>
                    {/*<ToggleScreenShareButton disabled={isReconnecting}/>*/}
                    <EndCallButton hideVideoChat={killChat}/>
                </>
            ) : (
                <>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        className={classes.button}
                        endIcon={<PlayArrow/>}
                        onClick={props.callConnect}
                    >
                        Join
                    </Button>
                    <CancelConnectButton hideVideoChat={killChat}/>
                </>
            )}
            <SettingsButton openSettings={() => setSettingsOpen(true)}/>
            <SettingsDialog
                open={settingsOpen}
                onClose={() => {
                    setSettingsOpen(false);
                }}
            />
        </div>

    );
}
